import React from "react";
import "../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "react-bootstrap";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Jin</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year}</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="mailto:xiaoping.jin.210@gmail.com"
                target="_blank"
                style={{ color: "white" }}
                rel="noopener noreferrer"
              >
                <i class="fas fa-envelope-square"></i>
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://github.com/fortdev210"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-github"></i>
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://join.skype.com/invite/gzmCUFdkFwx5"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white" }}
              >
                <i className="fab fa-skype"></i>
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/kot-jin/"
                style={{ color: "white" }}
                rel="noopener noreferrer"
                target="_blank"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://discord.gg/Qyxz864U"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white" }}
              >
                <i className="fab fa-discord"></i>
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
